// extracted by mini-css-extract-plugin
export default {"wrapper":"mobile-settings_wrapper__e46dK","back":"mobile-settings_back__TBTiv"};